module.exports = __webpack_public_path__ + "img/img_culture.3bec423b.jpg";